/* BVA Hydraulics — compatibility rules.
   Single source of truth, shared by the PDP cross-sell block and the configurator.
   All BVA 700-bar components use the same 3/8"-18 NPT quick coupling, so any BVA
   hose or coupling fits any BVA cylinder or pump. */
(function (global) {
  'use strict';

  var HOSE_FILL_CM3 = 15;   // oil left standing in a filled hose
  var MARGIN = 1.2;         // 20 % reserve so the pump is never emptied

  /* Cylinder oil demand. Falls back to the datasheet formula when the supplier
     has not stated a volume: effective area at 700 bar x stroke. */
  function oilRequired(cylinder) {
    if (cylinder.oil_required_cm3) return Number(cylinder.oil_required_cm3);
    var t = Number(cylinder.tonnage), s = Number(cylinder.stroke_mm);
    if (!t || !s) return null;
    return Math.round(t * 1.4 * (s / 10));
  }

  /* Smallest pump reservoir that can drive this cylinder through a full stroke. */
  function requiredPumpCapacity(cylinder) {
    var need = oilRequired(cylinder);
    return need === null ? null : Math.round(MARGIN * need + HOSE_FILL_CM3);
  }

  /* Rule 2 (sizing) + rule 3 (acting match). A double-acting cylinder needs a
     double-acting pump with a 4-way valve; single-acting works with any pump. */
  function isCompatible(cylinder, pump) {
    if (cylinder.acting === 'double' && pump.acting !== 'double') return false;
    var required = requiredPumpCapacity(cylinder);
    var capacity = Number(pump.oil_capacity_cm3);
    if (!capacity) return false;              // unknown reservoir - never guess
    if (required === null) return true;       // unknown demand - let the buyer decide
    return capacity >= required;
  }

  /* Compatible pumps, smallest sufficient first. The smallest that clears the
     rule is the cheapest, but a larger reservoir means fewer strokes - the UI
     shows both. */
  function matchingPumps(cylinder, pumps) {
    return pumps
      .filter(function (p) { return isCompatible(cylinder, p); })
      .sort(function (a, b) { return Number(a.oil_capacity_cm3) - Number(b.oil_capacity_cm3); });
  }

  /* How many hoses and couplings a circuit needs (rule 3). */
  function circuitCount(cylinder) {
    return cylinder && cylinder.acting === 'double' ? 2 : 1;
  }

  /* A complete kit: cylinder + pump + hose(s) + coupling(s) + gauge + adapter + oil.
     Gauge and oil are recommended, never required (rules 4-5). */
  function buildKit(cylinder, pump, parts) {
    var n = circuitCount(cylinder);
    var items = [];
    if (cylinder) items.push({ role: 'cylinder', product: cylinder, qty: 1, required: true });
    if (pump) items.push({ role: 'pump', product: pump, qty: 1, required: true });
    if (parts.hose) items.push({ role: 'hose', product: parts.hose, qty: n, required: true });
    if (parts.coupling) items.push({ role: 'coupling', product: parts.coupling, qty: n, required: true });
    if (parts.gauge) items.push({ role: 'gauge', product: parts.gauge, qty: 1, required: false });
    if (parts.gauge_adapter) items.push({ role: 'gauge_adapter', product: parts.gauge_adapter, qty: 1, required: false });
    if (parts.oil) items.push({ role: 'oil', product: parts.oil, qty: 1, required: false });
    return items;
  }

  /* 5 % bundle discount applies when the cart holds both a cylinder and a pump. */
  function qualifiesForBundle(items) {
    var hasCylinder = false, hasPump = false;
    items.forEach(function (i) {
      if (i.role === 'cylinder') hasCylinder = true;
      if (i.role === 'pump') hasPump = true;
    });
    return hasCylinder && hasPump;
  }

  function kitTotal(items) {
    return items.reduce(function (sum, i) {
      return sum + Number(i.product.price || 0) * i.qty;
    }, 0);
  }

  global.BVACompat = {
    oilRequired: oilRequired,
    requiredPumpCapacity: requiredPumpCapacity,
    isCompatible: isCompatible,
    matchingPumps: matchingPumps,
    circuitCount: circuitCount,
    buildKit: buildKit,
    qualifiesForBundle: qualifiesForBundle,
    kitTotal: kitTotal,
    BUNDLE_RATE: 0.05
  };
})(window);
